import { isPlatformBrowser } from '@angular/common';
import { Component, inject, Inject, PLATFORM_ID } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RouterLink } from '@angular/router';

export interface HeroSlide {
  image: string;
  tag: string;
  title: string;
  subtitle: string;
}

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './hero.html',
  styleUrl: './hero.scss',
})
export class Hero {
  private snackBar = inject(MatSnackBar);

  slides: HeroSlide[] = [
    {
      image: './home/1_.png',
      tag: 'Best Seller',
      title: 'Custom Printed Mugs',
      subtitle:
        'Design your personal ceramic mug with custom prints & artwork.',
    },
    {
      image: './home/2_.png',
      tag: 'Trending Now',
      title: 'Embroidered Caps',
      subtitle: 'Stand out with custom embroidered snapbacks and caps.',
    },
    {
      image: './home/3_.png',
      tag: 'Handcrafted Gift',
      title: 'Resin Initial Keychains',
      subtitle:
        'Personalized handcrafted resin key tags with glitter & initial letters.',
    },
    {
      image: './home/4_.png',
      tag: 'New Collection',
      title: 'Custom Graphic T-Shirts',
      subtitle: 'High quality custom printed tees with geek & gaming art.',
    },
    {
      image: './home/5_.png',
      tag: 'Personalized',
      title: 'Custom Water Bottles',
      subtitle: 'Stay hydrated in style with custom printed water bottles.',
    },
    {
      image: './home/6.png',
      tag: 'Best Seller',
      title: 'Custom Printed Mugs',
      subtitle:
        'Design your personal ceramic mug with custom prints & artwork.',
    },
    {
      image: './home/7.png',
      tag: 'Trending Now',
      title: 'Embroidered Caps',
      subtitle: 'Stand out with custom embroidered snapbacks and caps.',
    },
    {
      image: './home/8.png',
      tag: 'Handcrafted Gift',
      title: 'Resin Initial Keychains',
      subtitle:
        'Personalized handcrafted resin key tags with glitter & initial letters.',
    },
    {
      image: './home/9.png',
      tag: 'New Collection',
      title: 'Custom Graphic T-Shirts',
      subtitle: 'High quality custom printed tees with geek & gaming art.',
    },
    {
      image: './home/10.png',
      tag: 'Personalized',
      title: 'Custom Water Bottles',
      subtitle: 'Stay hydrated in style with custom printed water bottles.',
    },
    {
      image: './home/11.png',
      tag: 'Best Seller',
      title: 'Custom Printed Mugs',
      subtitle:
        'Design your personal ceramic mug with custom prints & artwork.',
    },
  ];

  images = this.slides.map((s) => s.image);
  currentIndex = 0;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      }, 4000);
    }
  }

  setSlide(index: number) {
    this.currentIndex = index;
  }

  onImageError(event: Event, index: number) {
    const target = event.target as HTMLImageElement;
    target.src = `./home/${(index % 5) + 1}.png`;
  }

  getStart() {
    this.snackBar.open('Coming soon...', 'Close', { duration: 5000 });
  }
}
